import request from '@/utils/request'

// 4.7.0辅导老师-----辅导老师招募
export function regAgent (data) {
  return request({
    url: '/ykt-web/agent/regAgent',
    method: 'post',
    data
  })
}

// 4.7.0辅导老师-----获取辅导老师详情-代理商前端
export function getAgentInfo (params) {
  return request({
    url: '/ykt-web/agent/getAgentInfo',
    method: 'get',
    params
  })
}
// 4.7.0辅导老师-----辅导老师,机构下级
export function pageAgentBind (data) {
  return request({
    url: '/ykt-web/agent/pageAgentBind',
    method: 'post',
    data
  })
}

// 4.6.0客户管理------代理商回显
export function selectById (params) {
  return request({
    url: '/ykt-web/agent/selectById',
    method: 'get',
    params
  })
}

// 4.9.0客户管理------代理商学员列表

export function listAgentTestUsers (data) {
  return request({
    url: '/ykt-web/agent/listAgentTestUsers',
    method: 'post',
    data
  })
}

// 4.9.0------发送短信
export function getMsgNum (params) {
  return request({
    url: '/ykt-web/agent/getMsgNum',
    method: 'get',
    params
  })
}

// sendMsg

export function sendMsg (data) {
  return request({
    url: '/ykt-web/agent/sendMsg',
    method: 'post',
    data
  })
}
